import axios, { AxiosInstance } from "axios";
import config from "../configs/config";
import { UIUtils } from "./uiUtils";

interface MenuItem {
  title: string;
  url: string;
}

interface MenuItems {
  [key: string]: MenuItem[];
}

class WordPressApi {
  private static instance: WordPressApi;
  private api: AxiosInstance;
  private cache: MenuItems = {};

  private constructor() {
    this.api = axios.create({
      baseURL: config.AFFORDA_STATIC_SITE,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public static getInstance(): WordPressApi {
    if (!WordPressApi.instance) {
      WordPressApi.instance = new WordPressApi();
    }
    return WordPressApi.instance;
  }

  private parentTitles = ["loans", "personal-finance", "benefits", "insights"];
  private displayTitles = ["Loans", "Personal Finance", "Benefits", "Insights"];

  public async fetchSubMenuItems(parentTitle: string, displayTitle?: string): Promise<MenuItem[]> {
    if (this.cache[parentTitle]) {
      return this.cache[parentTitle];
    }

    try {
      // Use displayTitle for API path if provided, otherwise use parentTitle
      const apiPathTitle = parentTitle;
      const response = await this.api.get(
        `/api/${apiPathTitle}/sitemap.json`
      );
      const items: MenuItem[] = response.data.map((item: any) => ({
        title: item.h1_title ? item.h1_title : item.title,
        url: item.url,
      }));

      this.cache[parentTitle] = items;
      return items;
    } catch (error) {
      const errorTitle = displayTitle || parentTitle;
      UIUtils.trackException(`Fetch sub-menu for ${errorTitle}`, error);
      return [];
    }
  }

  public async fetchAllSubMenuItems(): Promise<MenuItems> {
    const subMenuItems: MenuItems = {};

    // Use Promise.all to fetch all sub-menu items in parallel
    const fetchPromises = this.parentTitles.map(async (title, index) => {
      const displayTitle = this.displayTitles[index];
      subMenuItems[displayTitle] = await this.fetchSubMenuItems(title, displayTitle);
    });

    await Promise.all(fetchPromises);

    return subMenuItems;
  }
}

const wordpressApi = WordPressApi.getInstance();
export default wordpressApi;
